import { ISingleCompany } from '@typings'

export const MY_COMPANY_DEFAULT_VALUES: Partial<ISingleCompany> = {
  name: '',
  coc: '',
  tax: null,
  tax_payable: false,
}
